import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import itemSummaryReportTemplate from './itemSummaryReport.template.html';

/**
 * TODO: There is actually a duplicate code set in CSMBooksWeb/src/csmBooks/reports/itemOptionsReport/itemOptionsReport.js
 * Please read the comment in there.
 */
export default angular
  .module('books.ui.itemSummaryReport', [csmCommonWeb, booksService])
  .directive('itemSummaryReport', itemSummaryReportDirective).name;

/* @ngInject */
function itemSummaryReportDirective(BooksSvc, BusyScreen) {
  return {
    template: itemSummaryReportTemplate,
    scope: {
      dateLabel: '@' // Label for the input field.
    },
    link: function ($scope, element, attr) {
      /*---------------------------------------------------------*/
      /* Sets the defaults of the report to be pulled by account */
      /* and account name and puts the report in PDF format.     */
      /*---------------------------------------------------------*/
      $scope.req = {
        reportFormat: 'PDF',
        sortByName: true,
        categoryID: 0,
        itemID: 0
      };

      /*****************************************************************************
       * filterItems */
      /**
       * Filters the list of items based on the categoryID that is selected.
       *****************************************************************************/
      $scope.filterItems = function (item) {
        return (
          !$scope.req.categoryID || //All Categories
          !item.id || //All Items
          $scope.req.categoryID == item.categoryID
        );
      };

      /*---------------------------------------------*/
      /* Date validation, requires a date be entered */
      /*---------------------------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /*--------------*/
      /* Get services */
      /*--------------*/
      BooksSvc.getItemCategories().then(function (resp) {
        $scope.categoryList = [
          { categoryID: 0, category: 'All Categories' }
        ].concat(resp.data);

        BooksSvc.getOrganization().then(function (resp) {
          $scope.org = resp.data;

          BooksSvc.getProductList(null, false, false, false).then(function (
            resp
          ) {
            resp.data.sort(function (a, b) {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
            $scope.products = [{ id: 0, name: 'All Items' }].concat(resp.data);
          });
        });
        BusyScreen.setBusy(false);
      });
    }
  };
}
